var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tag,{tag:"component",class:[_vm.$style.container]},[_vm._v(" "+_vm._s(!_vm.shouldDisplay ? _vm.text : '')+" "),(_vm.shouldDisplay)?_c('span',{class:_vm.$style.placeholder,style:({ width: _vm.styleWidth, backgroundColor: _vm.shouldDisplay ? _vm.color : 'none' })},[_c('span',{class:_vm.$style.placeholderAnimation})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }